import http from "../../plugins/axios";

export default {
  getCoinWithdrawFeeConfigList(data){
    return http.get({
      url:'/admin/coinWithdrawFeeConfig/getCoinWithdrawFeeConfigList',
      data
    })
  },
  getCoinGroup(data){
    return http.get({
      url:'/admin/coinWithdrawFeeConfig/getCoinWithdrawFeeConfigListByGroupName',
      data
    })
  },
  getOfficeList(data){
    return http.get({
      url:'/admin/coinWithdrawFeeConfig/getCoinWithdrawFeeRecordList',
      data
    })
  },
  updateWithdraw(data){
    return http.post({
      url:'/admin/coinWithdrawFeeConfig/updateCoinWithdrawFeeConfig',
      data,
      dataType: "form"
    })
  },
  batchUpdate(data){
    return http.post({
      url:'/admin/coinWithdrawFeeConfig/batchUpdateCoinWithdrawFeeConfig',
      data,
      dataType: "form"
    })
  },
  
  getCoinTypes() {
    return http.get({
      url: '/admin/coin/allDisplay'
    });
  }
};
